import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Currency} from '../../models/currency';
import {Paginator} from '../../tools/pagination/paginator';
import {TableSorter} from '../../tools/table-sorter/table-sorter';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService extends AbstractModelService<Currency> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/currency', Currency);
  }

  findAllAvailable(
    params: any = {},
    paginator: Paginator | null = null,
    tableSorter: TableSorter | null = null
  ): Observable<Currency[]> {
    params['enabled'] = true;
    return super.findAll(
      params,
      paginator,
      tableSorter
    );
  }
}
